import React from 'react'
import PropTypes from 'prop-types'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table'
import {Button} from 'react-bootstrap'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'

class TimelineTable extends React.Component {
    onAfterInsertRow(row) {
        this.props.onAddRow(row)
    }
    customConfirm(next, dropRowKeys) {
        next()
    }
    onAfterDeleteRow(rowKeys) {
        this.props.onDeleteRow(rowKeys)
    }
    onAfterSaveCell(row, cellName, cellValue) {
        this.props.onEditRow(row)
    }
    onBeforeSaveCell(row, cellName, cellValue) {
        return true
    }
    addEmptyRow(){
        var fakeRow = {
            id: 'autovalue-'+new Date().getTime(),
            title: '',
        }
        // insert a new row
        var result = this._table.handleAddRow(fakeRow)   // this.refs.table is a ref for BootstrapTable
        if (result){  // some error happen, ex: doesn't assign row key or row key duplicated
            console.log(result)
        }
    }

    render() {
        let dataRows = this.props.dataRows ? this.props.dataRows : []
        const options = {
            afterInsertRow: this.onAfterInsertRow.bind(this),   // A hook for after insert rows
            handleConfirmDeleteRow: this.customConfirm.bind(this),
            afterDeleteRow: this.onAfterDeleteRow.bind(this),  // A hook for after droping rows.
            deleteText: this.props.deleteButtonText,
            defaultSortName: 'id',  // default sort column name
            defaultSortOrder: 'asc',  // default sort order
        }
        // If you want to enable deleteRow, you must enable row selection also.
        const selectRowProp = {
            mode: 'checkbox',
            bgColor: 'pink',
            hideSelectColumn: false,  // enable hide selection column.
            // clickToSelect: true,  // you should enable clickToSelect, otherwise, you can't select column.

        }
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            beforeSaveCell: this.onBeforeSaveCell.bind(this), // a hook for before saving cell
            afterSaveCell: this.onAfterSaveCell.bind(this),  // a hook for after saving cell
        }
        
        return (
            <div>
                <BootstrapTable 
                    hover
                    data={dataRows} 
                    options={options} 
                    insertRow={false} 
                    deleteRow={true} 
                    selectRow={selectRowProp}
                    cellEdit={cellEditProp}
                    ref={(c) => this._table = c}
                    //exportCSV={true}
                >
                    <TableHeaderColumn isKey autoValue={true} hidden dataField='id'>id</TableHeaderColumn>
                    <TableHeaderColumn dataField='title'>Event</TableHeaderColumn>
                </BootstrapTable>
                <Button bsStyle='success' onClick={this.addEmptyRow.bind(this)}>+ Add extra row</Button>
            </div>
        )
    }
}
TimelineTable.propTypes = {
    dataRows: PropTypes.array,
    deleteButtonText: PropTypes.string,
    onAddRow: PropTypes.func.isRequired,
    onEditRow: PropTypes.func.isRequired,
    onDeleteRow: PropTypes.func.isRequired,
}

TimelineTable.defaultProps = {
    deleteButtonText: 'Delete row(s)',
}
export default TimelineTable



// WEBPACK FOOTER //
// ./src/components/TimelineTable.js